module.exports = __webpack_public_path__ + "img/icon-drag-n-drop.4a4a5564.svg";